export const ALL_REQUESTS_PATH = '/all-requests';
export const MY_REQUESTS_PATH = '/my-requests';

export type TicketListAccessFlags = {
  isApprover?: boolean;
  isAdmin?: boolean;
  hasVisibleApprovals?: boolean;
};

export function canAccessApproverTicketList(flags: TicketListAccessFlags) {
  return Boolean(
    flags.isApprover || flags.isAdmin || flags.hasVisibleApprovals
  );
}

export function getTicketListPath(flags: TicketListAccessFlags) {
  return canAccessApproverTicketList(flags)
    ? ALL_REQUESTS_PATH
    : MY_REQUESTS_PATH;
}
